import React from 'react';

import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined';
import { Button, Typography, styled } from '@mui/material';

import FileUploader from '@/operator/components/general/input/FileUploader';
import { Invitation } from '@/operator/graphql/types/Invitation';

import { convertCsvFileToInvitationList } from '../../utils/convertCsvFileToInvitationList';

const StyledWidthWrapper = styled('div')(() => ({
    width: '100%',
}));

const StyledButton = styled(Button)(() => ({
    backgroundColor: '#5014ac',
    padding: '8px 15px',
    '&:hover': {
        backgroundColor: '#5014ac',
    },
    '&:disabled': {
        backgroundColor: 'rgb(211 182 255)',
    },
}));

const StyledButtonContainer = styled('div')(() => ({
    width: '100%',
    justifyContent: 'end',
    display: 'flex',
    marginBottom: '32px',
}));

interface UploadCsvFileProps {
    setInvitationList: React.Dispatch<React.SetStateAction<Invitation[]>>;
    csvFile: File;
    setCsvFile: React.Dispatch<React.SetStateAction<File>>;
}

const UploadCsvFile = ({
    setInvitationList,
    csvFile,
    setCsvFile,
}: UploadCsvFileProps) => {
    const fileReader = new FileReader();

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFiles = event.target.files;
        if (!newFiles) {
            return;
        }

        setCsvFile(newFiles[0]);
    };

    const onLoadCsvFile = (event: ProgressEvent<FileReader>) => {
        const text = event.target.result;
        const invitationList = convertCsvFileToInvitationList(text);
        setInvitationList(invitationList);
    };

    const handleOnSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (csvFile) {
            fileReader.onload = function (event) {
                onLoadCsvFile(event);
            };

            fileReader.readAsText(csvFile);
        }
    };

    return (
        <StyledWidthWrapper>
            <FileUploader
                label="Upload a file"
                subLabel="CSV only"
                accept=".csv"
                onChange={handleOnChange}
                containerStyle={{
                    backgroundColor: 'rgb(247, 246, 255, 1)',
                    marginBottom: '25px',
                }}
            />
            <StyledButtonContainer>
                <StyledButton
                    disabled={!csvFile}
                    onClick={handleOnSubmit}
                    size="small"
                >
                    <CloudUploadOutlined
                        sx={{ color: 'white', marginRight: '15px' }}
                    />
                    <Typography variant="h5" color="white" sx={{ margin: 0 }}>
                        Upload
                    </Typography>
                </StyledButton>
            </StyledButtonContainer>
        </StyledWidthWrapper>
    );
};

export default UploadCsvFile;
